<template>
    <div>
      <el-form>
        <el-form-item>
          文件名称：
          <el-input style="width:50%" type="file" v-model="excelFile"></el-input>
        </el-form-item>
        <el-button @click="importExcel">导入</el-button>
      </el-form>
    </div>
</template>

<script>
    export default {
      name: "ImportExcel",
      data(){
        return {
          excelFile: '',
        }
      },
      methods: {
        importExcel(){
          this.$inbound.post({
            interfaceId: 'exportImport',
            data: {
              excelFile: this.excelFile
            }
          }).then(response => {
            console.log(response)
          }).catch(error => {
            console.log(error)
          })
        }
      }
    }
</script>

<style scoped>

</style>
